// ToDoTab's read (finance-real, the user 2026-10-23): To do on jobs, its groups and their totals the server's.
import type { UseQueryResult } from "@tanstack/react-query";
import { useJobsToDo } from "../../hooks/useAgencyTabs";
import type { JobsToDo } from "../../types";

export type ToDoTabModel = UseQueryResult<JobsToDo>;

export function useToDoTab(): ToDoTabModel {
  return useJobsToDo();
}
